import { SessionManager } from './sessionManager';

export const auth = {
  getToken: (): string | null => {
    // BFF pattern — no client-side tokens
    return null;
  },

  isAuthenticated: (): boolean => {
    // Check session existence via SessionManager (cookie auth is handled server-side)
    const session = SessionManager.getCurrentSession();
    return session !== null;
  }
};
